/**
 * ActiveStreamDots — the "in line loading" dots on a sidebar chat row.
 *
 * Three 4px brand dots with a 4px gap, each fading + scaling in and out on a 2s
 * loop, staggered.
 */

import { cn } from 'src/utils/utils';

/** Cycle is 2s; each dot is staggered by 0.1 of it. */
const DOT_DELAYS_MS = [0, 200, 400] as const;

export interface ActiveStreamDotsProps {
  className?: string;
}

export default function ActiveStreamDots({
  className
}: ActiveStreamDotsProps) {
  return (
    <span
      role="status"
      aria-label="Still responding"
      title="Still responding…"
      className={cn(
        'tw:flex tw:shrink-0 tw:items-center tw:gap-2xs',
        className
      )}
    >
      {DOT_DELAYS_MS.map((delay) => (
        <span
          key={delay}
          aria-hidden
          className="tw:size-2xs tw:shrink-0 tw:rounded-full tw:bg-icon-brand tw:animate-stream-dot"
          style={{ animationDelay: `${delay}ms` }}
        />
      ))}
    </span>
  );
}
